import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field} from 'redux-form';
import moment from 'moment';
import {Card, Button, Input, Checkbox, Form, Icon} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {ORIGIN} from '../../../../common/forms';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {originModificationDate} from '../../../../common/constants/datesFormat';
import {paths} from '../../../../common/dictionaries/urls';

class OriginForm extends Component {
  componentDidMount() {
    const {permissions, selectedOrigin} = this.props;
    if (
      !(
        (hasAccessPermission(permissions, resources.Origins, scopes.Edit) &&
          selectedOrigin) ||
        (hasAccessPermission(permissions, resources.Origins, scopes.Create) &&
          !selectedOrigin)
      )
    ) {
      this.props.push(paths.AccessDenied);
      return;
    }
    if (selectedOrigin) {
      this.props.initializeOriginData(selectedOrigin);
    }
  }

  onCancelClick() {
    this.props.goBack();
  }

  renderCheckBox = ({input, label, readOnly}) => {
    return (
      <Form.Field>
        <Checkbox
          toggle
          label={label}
          checked={input.value ? true : false}
          onChange={(e, {checked}) => input.onChange(checked)}
          readOnly={readOnly}
        />
      </Form.Field>
    );
  };

  renderStatus = (selectedOrigin) => {
    if (
      hasAccessPermission(
        this.props.permissions,
        resources.Origins,
        scopes.Disabled
      )
    ) {
      return (
        <>
          <div className='field-label'>
            <label>Estado</label>
          </div>
          <div className='field-component'>
            <Field
              toggle
              name='status'
              component={this.renderCheckBox}
              readOnly={selectedOrigin ? false : true}
            />
          </div>
        </>
      );
    }
    return null;
  };

  renderLastmodificationDate = (selectedOrigin) => {
    if (selectedOrigin) {
      return (
        <>
          <div className='field-label'>
            <label>Última Modificación</label>
          </div>
          <div className='field-component'>
            <p>
              {moment(selectedOrigin.modificationDate).format(
                originModificationDate
              )}
            </p>
          </div>
        </>
      );
    }
    return null;
  };

  renderCode = (selectedOrigin) => {
    if (!selectedOrigin) {
      return (
        <Field
          name='code'
          component={Input}
          required
          maxLength='7'
          type='text'
          onInvalid={(event) => {
            event.stopPropagation();
            event.target.setCustomValidity('Por favor, llene este campo');
          }}
          onInput={(event) => {
            event.stopPropagation();
            event.target.setCustomValidity('');
          }}
        />
      );
    }
    return (
      <p>
        <b>{selectedOrigin.code}</b>
      </p>
    );
  };

  renderOrigin = () => {
    return (
      <Field
        name='origin'
        component={Input}
        required
        maxLength='100'
        type='text'
        onInvalid={(event) => {
          event.stopPropagation();
          event.target.setCustomValidity('Por favor, llene este campo');
        }}
        onInput={(event) => {
          event.stopPropagation();
          event.target.setCustomValidity('');
        }}
      />
    );
  };

  render() {
    const {selectedOrigin, handleSubmit, submitting} = this.props;

    return (
      <Form
        className='origin-form'
        onSubmit={handleSubmit}
        loading={submitting}
      >
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onCancelClick.bind(this)} />
              <h2>{selectedOrigin ? 'Editar Origen' : 'Añadir Origen'}</h2>
              <div className='title-bar-actions'>
                <Button
                  type='button'
                  secondary
                  className='toyota-secondary'
                  onClick={this.onCancelClick.bind(this)}
                  disabled={submitting}
                >
                  Cancelar
                </Button>
                <Button
                  primary
                  type='submit'
                  className='toyota-primary'
                  disabled={submitting}
                >
                  Guardar
                </Button>
              </div>
            </div>
          </div>
        </Card>

        <Card raised fluid>
          <div className='page-content'>
            <div className='field-label'>
              <label>Código*</label>
            </div>
            <div className='field-component'>
              {this.renderCode(selectedOrigin)}
            </div>
            <div className='field-label'>
              <label>Origen*</label>
            </div>
            <div className='field-component'>{this.renderOrigin()}</div>
            {this.renderStatus(selectedOrigin)}
            {this.renderLastmodificationDate(selectedOrigin)}
          </div>
        </Card>
      </Form>
    );
  }
}

export {OriginForm};

const form = reduxForm({
  'form': ORIGIN.name,
  'initialValues': ORIGIN.initialValues,
})(OriginForm);

const mapStateToProps = (state, ownProps) => {
  return {
    'selectedOrigin': ownProps.selectedOrigin,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'goBack': ownProps.goBack,
    'push': ownProps.push,
  };
};

const {initializeOriginData} = Actions;

export default connect(mapStateToProps, {
  initializeOriginData,
})(form);
